import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import OfficeEquipmentStoragePage from '@/v2/components/pages/public-pages/office-equipment-storage-page'
import {
  faqSectionContent,
  metaImages,
  ogImages
} from '@/v2/constants/pages/public-pages/office-equipment-storage-page'

interface OfficeEquipmentStoragePageProps {}

const Page: React.FC<OfficeEquipmentStoragePageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.office_equipment_storage.title ?? ''}
        keywords={META_CONTENTS.office_equipment_storage?.keywords ?? ''}
        description={META_CONTENTS.office_equipment_storage?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <OfficeEquipmentStoragePage />
    </>
  )
}

export default Page
